var saunaproducts = [];
var saunacomponents = [];
var componentdata = [];
var joinedvariants;
var saunatimestamp;

const saunaswiper = new Swiper('.saunaform', {
  
  loop: false,
  autoHeight: false,
  simulateTouch: false,
  effect: 'fade',
  allowTouchMove: false,
  fadeEffect: {
  crossFade: true
},
});



const sizeswiper = new Swiper('.sizeslider', {
  
    loop: true,
    autoHeight: false,
    
      effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },

  navigation: {
    nextEl: '.nextbtn',
    prevEl: '.previousbtn',
  },
});


const controllerswiper = new Swiper('.controllerslider', {
  
    loop: true,
    autoHeight: false,
    pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
      clickable: true,
  },
    
      effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  navigation: {
    nextEl: '.nextbtn',
    prevEl: '.previousbtn',
  },
});



const additionalswiper = new Swiper('.additionalslider', {
  
    loop: true,
    autoHeight: false,

      pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
        clickable: true,
  },
    
      effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  navigation: {
    nextEl: '.nextbtn',
    prevEl: '.previousbtn',
  },
});

var reviewsliderobj;

function reviewslider() {
reviewsliderobj = new Swiper('.reviewslider', {
  
    loop: true,
    autoHeight: false,
    observer: true,
    pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
    
      effect: 'fade',
  fadeEffect: {
    crossFade: true
  },

  navigation: {
    nextEl: '.nextbtn',
    prevEl: '.previousbtn',
  },
});
  }

$( ".saunaform").on( "click", "[data-buildsauna], .optionselected nextstep", function() {
  saunaswiper.slideNext();
    if ($(window).width() < 1008) {
     window.scrollTo({ top:50, left:0, behavior: "instant"});
  }
});

$( ".saunaform").on( "click", '[data-hash="controller"] nextstep', function() {
  var featuredimg = $(".swatchinput:checked").data('imgsrc');
  $('.controllerimagereview').attr("src",featuredimg);
});



$('previousstep').click(function() {
  saunaswiper.slidePrev();
});

$('.controllertype').click(function() {

if (!$(this).hasClass('activeoption')) {
$('.controllerswatches input').prop('checked',false);
$('.controllerswatches').removeClass('selectedswatch');
$('.controllertype').removeClass('activeoption');
$(this).addClass('activeoption');
$(this).closest('saunaformitem').removeClass('optionselected');
controllerswiper.slideTo(1);
}

$('controllerfinishes').addClass('controllertypeselected');
if ($(this).prop("tagName") == 'LOCALCONTROLLER') {
    $('wifiswatches').removeClass('swatchtypeselected');
    $('localswatches').addClass('swatchtypeselected');
}
else {
    $('localswatches').removeClass('swatchtypeselected');
    $('wifiswatches').addClass('swatchtypeselected');
}
});

$('.controllerswatches').click(function() {
var controllertype = $(this).data('controllertype');
var controllercolor = $(this).data('color');
var slideindex = $(this).data('index');

controllerswiper.slideTo(slideindex);	
$('.controllerswatches').removeClass('selectedswatch');
$(this).addClass('selectedswatch');
$('.controllerswatches input').prop('checked',false);
$(this).find('input').prop('checked',true);
$(this).closest('saunaformitem').addClass('optionselected');
$('#controllertype').html(`${controllertype}, ${controllercolor}`);
});

$('sizeitem').click(function() {
var sizemediaid = $(this).data('sizestripped');
var requiresextension = $(this).data('extensionbox');
if (requiresextension == true) {
  $('#extensionbox').attr('checked', true);
  $('#reviewextension').show();
}
else {
  $('#extensionbox').attr('checked', false);
  $('#reviewextension').hide();
}
  
$( ".sizeitem.swiper-slide" ).each(function(index) {
var sizedata = $(this).data('mediaalt');
if(sizedata == sizemediaid) {
  var mediaindex = $(this).data('sizeindex');
  sizeswiper.slideTo(mediaindex);	
}
});
  
  
var stonemultiplier = $(this).data('stonemultiplier');
var sizetext = $(this).data('size');
var capacitytext = $(this).data('capacity');
var stoneqty = $(this).data('stoneqty');
$(this).closest('saunaformitem').addClass('optionselected');
$('#sizedetails').html(`${sizetext}, ${capacitytext}`);
$('#stonesrequired').html(`${stoneqty}`);
$('#stonebase').attr('data-qty',stonemultiplier);
});


if($('#includereflect').length > 0) {
    $('#includereflect,#dontincludereflect').click(function() {
        $(this).closest('saunaformitem').addClass('optionselected');
    });
}
else {
    $('#includeflange,#dontincludeflange').click(function() {
        $(this).closest('saunaformitem').addClass('optionselected');
    });
}


var reviewinit = false;

$('#reviewsauna').click(function() {
    var saunaprice = 0;
    var stonemultiplier;
    var dataprice;
    var joinedvariants;
    saunatimestamp = Date.now();
    saunaproducts = [];
    saunacomponents = [];
    componentdata = [];
    saunaproducts.push({
        'items': []
    });


if (!(reviewinit == true)) {
reviewslider(); 
}


var includeflange;
var includereflect;
var flangecontain = $('.flangeimg').html();
var reflectcontain = $('.reflectimg').html();
  
if ($('#dontincludeflange:checked').length > 0) {

var flangeslide = $('.reviewslider .flangeslide').length;

if (flangeslide > 0) {
  var flangeindex = $('.reviewslider .flangeslide').data('swiper-slide-index');
  reviewsliderobj.removeSlide(flangeindex);	
}
  
includeflange = false;
}
  
else {
 
if (!(includeflange == true)) {
reviewsliderobj.addSlide(1, `${flangecontain}`) 
}
includeflange = true;
  
}


if ($('#dontincludereflect:checked').length > 0) {

var reflectslide = $('.reviewslider .reflectslide').length;

if (reflectslide > 0) {
  var reflectindex = $('.reviewslider .reflectslide').data('swiper-slide-index');
  reviewsliderobj.removeSlide(reflectindex);	
}
  

includereflect = true;
}
else {

if (!(includereflect == true)) {
reviewsliderobj.addSlide(1, `${reflectcontain}`) 
}
includereflect = true;

}

reviewinit = true;  
 

var variantsdetails;
var qty;
var price;
var componentdetails;
var componentname;
  
  $('.saunaform input:checked').each(function(i, obj) {

    
    if ($(this).data('name') && $(this).data('details') && $(this).data('price') && $(this).data('qty') && $(this).data('variantid')) {
  componentname = $(this).data('name');
  componentdetails = $(this).data('details');
  qty = $(this).data('qty');
  price = $(this).data('price');
  variantsdetails = $(this).data('variantid');
      
      saunacomponents.push({[componentname]: componentdetails});
      componentdata.push(`${variantsdetails}`);
      joinedvariants = componentdata.join(",");

      

      dataprice = price * qty;

      console.log(i, dataprice);
      
      saunaprice = saunaprice + dataprice;
   
    }
  });


    
    $('.saunaform input:checked').each(function(i, obj) {
        
        if ($(this).data('name') && $(this).data('details') && $(this).data('price') && $(this).data('qty') && $(this).data('variantid')) {
            var variantid = $(this).data('variantid');
            var qty = $(this).data('qty');
            var price = $(this).data('price');
            var type = $(this).attr('name');

            if (type == 'saunasize') {
                saunaproducts[0].items.push({
                    'id': variantid, 
                    'quantity':  qty,
                    properties: {
                      ...saunacomponents[0],
                      ...saunacomponents[1],
                      ...saunacomponents[2],
                      ...saunacomponents[3],
                      ...saunacomponents[4],
                      ...saunacomponents[5],
                      ...saunacomponents[6],
                      ...saunacomponents[7],
                      ...saunacomponents[8],
                      ...saunacomponents[9],
                      ...saunacomponents[10],
                      '_variants': joinedvariants,
                      '_total': saunaprice,
                      '_timestamp': saunatimestamp
                      }
                });
             }
           else {
                    saunaproducts[0].items.push({
                    'id': variantid, 
                    'quantity':  qty,
                      properties: {
                    '_timestamp': saunatimestamp
                      }
                });
           }
       
        }

    });

  console.log(saunaproducts[0].items);

  var adjustedprice = saunaprice / 100;
  //var adjustedpricediscounted = adjustedprice * 0.9;

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  

  $('#saunatotalprice').html(formatter.format(adjustedprice));
  //$('#saunatotalpricediscounted').html(formatter.format(adjustedpricediscounted));


});


$('[data-addsauna]').click(function() {
    var addproducts = JSON.stringify(saunaproducts[0]);
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: addproducts
      })
      .then(response => {
        
        document.dispatchEvent(new CustomEvent('cart:build'));  
        document.dispatchEvent(new CustomEvent('cart:open'));  
        
      })
});



$('.flangeoption').click(function() {
var flangeoption = $(this).data('val');
$('#flangedetails').html(flangeoption);
var flangeindex = ($('.firstflangeimage:not(.swiper-slide-duplicate)').data('swiper-slide-index')) + 1;
additionalswiper.slideTo(flangeindex);
});


$('.reflectoption').click(function() {
var reflectoption = $(this).data('val');
$('#reflectdetails').html(reflectoption);
var reflectorindex = ($('.firstreflectimage:not(.swiper-slide-duplicate)').data('swiper-slide-index')) + 1;
additionalswiper.slideTo(reflectorindex);
});


$('.editsauna').click(function() {
var step = $(this).data('edit');
saunaswiper.slideTo(step)	
});

